import(/* webpackMode: "eager" */ "/app/packages/marginly-landing/components/main/sparks.tsx")